import React, { Component } from 'react';
import { HideUntilLoaded } from 'react-animation'
import { connect } from 'react-redux';

class CardRespostaFatoFake extends Component {

    css = {
        width: "100%"
    };

    render() {
        let i18n = this.props.i18n
        return (
            <div>
                <div className="card weex-card-interno">
                    <div className="conteudo-card-atividades">
                        <div className="card-image">
                            <HideUntilLoaded style={this.css}>
                                {this.props.resposta === this.props.fatoFake.fact ? (
                                    <figure className="weex-card-container-imagem my-4">
                                        <img src="/feito.png" alt="Resposta certa" className="weex-card-imagem-resposta-certo-errado" />
                                    </figure>
                                ) : (
                                    <figure className="weex-card-container-imagem my-4">
                                        <img src="/ops.png" alt="Resposta errada" className="weex-card-imagem-resposta-certo-errado" />
                                    </figure>
                                )}
                                {this.props.fatoFake.fact ? (
                                    <div>
                                        <figure className="weex-card-container-imagem">
                                            <img src="/positivo.png" alt="Fato" className="weex-card-imagem-resposta-fato-fake" />
                                        </figure>
                                        <div className="texto-fato-fake">{i18n.message("dinamica.fatofake.fato", "FATO!")}</div>
                                    </div>
                                ) : (
                                    <div>
                                        <figure className="weex-card-container-imagem">
                                            <img src="/negativo.png" alt="Fake" className="weex-card-imagem-resposta-fato-fake" />
                                        </figure>
                                        <div className="texto-fato-fake">{i18n.message("dinamica.fatofake.fake", "FAKE!")}</div>
                                    </div>
                                )}
                            </HideUntilLoaded>
                        </div>
                        <div className="card-content">
                            <div className="content weex-card-interno__content weex-card-interno__content__fato-fake">
                                <div dangerouslySetInnerHTML={  {__html: this.props.fatoFake.answer}   }></div>
                            </div>
                            {this.props.ultimo ? (
                                <button className="weex-button weex-botao-confirmacao" onClick={this.props.finalizar}>
                                    {i18n.message("dinamica.fatofake.concluir", "CONCLUIR!")}
                                </button>
                            ) : (
                                <button className="weex-button weex-botao-confirmacao weex-botao-confirmacao__texto-comprido" onClick={this.props.proximoFatoFake}>
                                    {i18n.message("dinamica.fatofake.proxima", "PRÓXIMA PERGUNTA!")}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(CardRespostaFatoFake)